import {
  calculateAutoloadTaxSetOff,
  calculateCorporateRebate,
  calculateExemption,
  getManualTaxPreviouslyAssessedRows,
} from "../shared";

const hasValue = (value) =>
  value !== null && value !== undefined && value !== "";

const getNumber = (value, fallback = 0) => {
  if (!hasValue(value)) return fallback;
  const amount = parseFloat(value);
  return Number.isNaN(amount) ? fallback : amount;
};

export const resolveIrasChargeableIncomeSummary = ({
  chargeableIncomeBeforeExemptAmount,
  computedSummary = {},
  corporateIncomeTaxRebate = {},
  currentYearRebate = {},
  isStartup,
  taxPreviouslyAssessed = [],
}) => {
  const hasResolvedChargeableIncome = hasValue(
    chargeableIncomeBeforeExemptAmount
  );
  const resolvedChargeableIncome = getNumber(
    hasResolvedChargeableIncome
      ? chargeableIncomeBeforeExemptAmount
      : computedSummary.chargebleIncomeBeforeExemptAmount
  );
  const calculatedExemption = calculateExemption(
    resolvedChargeableIncome,
    Boolean(isStartup)
  );
  const firstExemptAmount = hasResolvedChargeableIncome
    ? calculatedExemption.firstExemptAmount
    : hasValue(computedSummary.firstExemptAmount)
      ? getNumber(computedSummary.firstExemptAmount)
      : calculatedExemption.firstExemptAmount;
  const secondExemptAmount = hasResolvedChargeableIncome
    ? calculatedExemption.secondExemptAmount
    : hasValue(computedSummary.secondExemptAmount)
      ? getNumber(computedSummary.secondExemptAmount)
      : calculatedExemption.secondExemptAmount;
  const chargeableIncomeAfterExemptAmount = hasResolvedChargeableIncome
    ? resolvedChargeableIncome - firstExemptAmount - secondExemptAmount
    : hasValue(computedSummary.chargebleIncomeAfterExemptAmount)
      ? getNumber(computedSummary.chargebleIncomeAfterExemptAmount)
      : resolvedChargeableIncome - firstExemptAmount - secondExemptAmount;
  const taxableIncome = hasResolvedChargeableIncome
    ? (Math.round(chargeableIncomeAfterExemptAmount) * 0.17).toFixed(2)
    : hasValue(computedSummary.taxableIncome)
      ? getNumber(computedSummary.taxableIncome)
      : (Math.round(chargeableIncomeAfterExemptAmount) * 0.17).toFixed(2);
  const autoloadTaxSetOff = calculateAutoloadTaxSetOff(taxPreviouslyAssessed);
  const postDeductions = hasResolvedChargeableIncome
    ? Number(taxableIncome) + Number(autoloadTaxSetOff)
    : hasValue(computedSummary.postDeductions)
      ? getNumber(computedSummary.postDeductions)
      : Number(taxableIncome) + Number(autoloadTaxSetOff);
  const previousTax = getManualTaxPreviouslyAssessedRows(
    taxPreviouslyAssessed
  )[0] || {
    label: "",
    amount: 0,
  };
  const rebate = calculateCorporateRebate({
    corporateIncomeTaxRebate,
    currentYearRebate,
    postDeductions,
  });
  const taxPayableBeforeEci =
    resolvedChargeableIncome <= 0
      ? 0
      : postDeductions - Number(rebate.netRebate);
  const netTaxPayable = hasResolvedChargeableIncome
    ? postDeductions - Number(rebate.netRebate) + (previousTax.amount || 0)
    : hasValue(computedSummary.netTaxPayable)
      ? getNumber(computedSummary.netTaxPayable)
      : postDeductions - Number(rebate.netRebate) + (previousTax.amount || 0);

  return {
    autoloadTaxSetOff,
    chargeableIncomeAfterExemptAmount,
    chargeableIncomeBeforeExemptAmount: resolvedChargeableIncome,
    exemption: calculatedExemption,
    firstExemptAmount,
    netTaxPayable,
    postDeductions,
    previousTax,
    rebate,
    secondExemptAmount,
    taxPayableBeforeEci,
    taxableIncome,
  };
};
